const NAMESPACE = 'robinLayout'

export { NAMESPACE }
